import AccountTreeOutlined from '@mui/icons-material/AccountTreeOutlined'
import ChatOutlined from '@mui/icons-material/ChatOutlined'
import GroupsOutlined from '@mui/icons-material/GroupsOutlined'
import SmartToyOutlined from '@mui/icons-material/SmartToyOutlined'

export const categoryMeta = {
  training_process: { label: '综合训练', Icon: AccountTreeOutlined, color: 'primary' },
  group_chat_template: { label: '团队协作', Icon: GroupsOutlined, color: 'success' },
  expert_agent: { label: '专项训练', Icon: SmartToyOutlined, color: 'warning' },
}

export const timelineLabel = { stage: '阶段', week: '周', day: '天', unit: '单元' }

/** 作业路径前缀：阶段3 / 第2周 / 第4天 / 单元1，可带阶段标题；无路径信息时返回空串 */
export const homeworkPathPrefix = (item, timelineUnit) => {
  const unit = timelineLabel[timelineUnit] || '阶段'
  const no = Number(item?.sectionNo) || 0
  const sectionTitle = String(item?.sectionTitle || '').trim()
  let prefix = ''
  if (no > 0) {
    prefix = (unit === '周' || unit === '天') ? `第${no}${unit}` : `${unit}${no}`
  }
  if (sectionTitle && sectionTitle !== prefix) {
    prefix = prefix ? `${prefix} ${sectionTitle}` : sectionTitle
  }
  return prefix
}

const collator = typeof Intl !== 'undefined'
  ? new Intl.Collator('zh-CN', { numeric: true, sensitivity: 'base' })
  : null

const cmpText = (a, b) => (collator ? collator.compare(a, b) : String(a).localeCompare(String(b), 'zh-CN'))

/** 有前缀的在前，再按前缀、作业名字符序；无前缀仍可排（空前缀靠后） */
export const compareHomeworkByPathTitle = (a, b, timelineUnit) => {
  const pa = homeworkPathPrefix(a, timelineUnit || a?.timelineUnit)
  const pb = homeworkPathPrefix(b, timelineUnit || b?.timelineUnit)
  const aRank = pa ? 0 : 1
  const bRank = pb ? 0 : 1
  if (aRank !== bRank) return aRank - bRank
  const byPrefix = cmpText(pa, pb)
  if (byPrefix !== 0) return byPrefix
  return cmpText(a?.title || a?.Title || '', b?.title || b?.Title || '')
}

export const FallbackIcon = ChatOutlined

export const studentIdOf = (user) => (
  user?.unified_user_id || user?.studentID || user?.student_id || ''
)

/** 作业四态文案：与 student_training_details.assignment_status 对齐 */
export const homeworkStatusLabel = (status) => ({
  '1': '未提交',
  '2': '已提交',
  '3': '已完成评价',
  '4': '已打回',
  unsubmitted: '未提交',
  submitted: '已提交',
  evaluated: '已完成评价',
  rejected: '已打回',
  // 兼容旧 progress.status 文案（过渡期）
  upcoming: '未提交',
  pending_review: '已提交',
  done: '已完成评价',
  active: '未提交',
})[String(status)] || '未知'
